import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of, from} from 'rxjs';
import { MerchantAccountService } from "../services";
import { catchError, switchMap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class WorkflowPackageResolver implements Resolve<boolean> {
    constructor(private readonly merchantAccountService: MerchantAccountService, private readonly router: Router) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const packageId = +route.queryParams["packageId"];
        const merchantAccount = this.merchantAccountService.getMerchantAccountIdByPackageId(packageId)
            .pipe(catchError(error => {
                return of(null);
            }))
            .pipe(switchMap((merchantAccountId) => {
                if (!merchantAccountId) return of(null);
                return from(this.router.navigate(['account', merchantAccountId]));
            }));
        return merchantAccount as Observable<boolean>;
    }
}